import React, { useState, useEffect } from 'react';
import '../App.css'; // Reusing common modal styles

function AddBranchModal({ isOpen, onClose, onAddBranch, branchData, setBranchData }) {
  const headquartersOptions = [
    "서울본부", "남서울본부", "인천본부", "경기북부본부", "경기본부", 
    "강원본부", "충북본부", "대전세종충남본부", "전북본부", "광주전남본부", 
    "대구본부", "경북본부", "부산울산본부", "경남본부", "제주본부"
  ];

  const branchMap = {
    "서울본부": [
      "서울본부직할", "동대문중랑지사", "서대문은평지사", "강북성북지사", 
      "광진성동지사", "마포용산지사", "노원도봉지사"
    ],
    "남서울본부": [
      "남서울본부직할", "강서양천지사", "관악동작지사", "강동송파지사",
      "구로금천지사", "강남지사", "서초지사"
    ],
    "인천본부": [
      "인천본부직할", "남인천지사", "부천지사", "김포지사", "제물포지사",
      "서인천지사", "시흥지사", "강화지사", "영종지사", "백령지사"
    ],
    "경기북부본부": [
      "경기북부본부직할", "고양지사", "파주지사", "구리지사", "양평지사",
      "포천지사", "남양주지사", "동두천지사", "가평지사", "연천지사"
    ],
    "경기본부": [
      "경기본부직할", "안양군포의왕지사", "안산지사", "성남지사", "오산지사",
      "평택지사", "화성지사", "광주지사", "서수원지사", "서용인지사",
      "안성지사", "이천지사", "서평택지사", "동용인지사", "여주지사",
      "하남지사", "광명지사"
    ],
      "강원본부": [
      "강원본부직할", "원주지사", "강릉지사", "홍천지사", "횡성지사", "속초고성지사", 
      "철원지사", "삼척지사", "영월지사", "동해지사", "인제지사", "양구지사", "태백지사",
      "양양지사", "화천지사", "평창지사", "정선지사",
    ],
      "충북본부": [
      "충북본부직할", "동청주지사", "충주지사", "제천지사", "진천지사",
      "증평괴산지사", "음성지사", "영동지사", "보은지사", "옥천지사",
      "단양지사",
    ],
      "대전세종충남본부": [
      "대전세종충남본부직할", "천안지사", "대덕유성지사", "아산지사", "서대전지사",
      "세종지사", "당진지사", "서산지사", "보령지사", "논산지사",
      "공주청양지사","홍성지사", "태안지사", "부여지사", "예산지사", "금산지사","서천지사",
    ],
      "전북본부": [
      "전북본부직할", "익산지사", "군산지사", "남전주지사", "김제지사",
      "정읍지사", "남원지사", "고창지사", "부안지사", "임실지사",
      "진안지사","장수지사", "순창지사", "무주지사",
    ],
      "광주전남본부": [
      "광주전남본부직할", "여수지사", "순천지사", "광산지사", "서광주지사",
      "목포지사", "나주지사", "해남지사", "고흥지사", "영암지사",
      "화순지사","광양지사", "보성지사", "무안지사", "영광지사", "강진지사","장성지사",
      "장흥지사", "담양지사", "진도지사", "곡성지사", "완도지사",
      "신안지사", "구례지사", "함평지사",
    ],
      "대구본부": [
      "대구본부직할", "동대구지사", "경주지사", "남대구지사", "서대구지사",
      "포항지사", "경산지사", "김천지사", "영천지사", "칠곡지사",
      "성주지사","청도지사", "북포항지사", "고령지사", "영덕지사", "울릉지사",
    ],
      "경북본부": [
      "경북본부직할", "구미지사", "상주지사", "영주지사", "의성지사",
      "문경지사", "예천지사", "봉화지사", "울진지사", "군위지사",
      "청송지사","영양지사",
    ],
      "부산울산본부": [
      "부산울산본부직할", "울산지사", "김해지사", "동래지사", "남부산지사",
      "양산지사", "중부산지사", "북부산지사", "동울산지사", "서부산지사",
      "기장지사","서울산지사", "영도지사",
    ],
      "경남본부": [
      "경남본부직할", "진주지사", "마산지사", "거제지사", "밀양지사",
      "사천지사", "통영지사", "거창지사", "함안의령지사", "창녕지사",
      "합천지사","진해지사", "하동지사", "고성지사", "산청지사", "남해지사","함양지사",
    ],
      "제주본부": [
      "제주본부직할", "서귀포지사",
    ],
    // Other headquarters will be added here
  };

  const [branchOptions, setBranchOptions] = useState([]);

  useEffect(() => {
    if (branchData.headquarters) {
      setBranchOptions(branchMap[branchData.headquarters] || []);
    } else {
      setBranchOptions([]);
    }
  }, [branchData.headquarters]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBranchData(prev => ({ ...prev, [name]: value }));
  };

  const handleHeadquartersChange = (e) => {
    const { value } = e.target;
    setBranchData(prev => ({
      ...prev,
      headquarters: value,
      name: '' // Reset branch name
    }));
  };

  const handleAddressSearch = () => {
    const width = 500;
    const height = 600;
    new window.daum.Postcode({
      oncomplete: function(data) {
        setBranchData(prev => ({ ...prev, address: data.address }));
      }
    }).open({
      left: (window.screen.width / 2) - (width / 2),
      top: (window.screen.height / 2) - (height / 2)
    });
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-button" onClick={onClose}>×</button>
        <h1>신규 지사 등록</h1>
        <form onSubmit={onAddBranch} className="branch-form-modal">
          <div className="form-group">
            <label>본부</label>
            <select name="headquarters" value={branchData.headquarters} onChange={handleHeadquartersChange} required>
              <option value="">본부를 선택하세요</option>
              {headquartersOptions.map(hq => <option key={hq} value={hq}>{hq}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>지사</label>
            <select name="name" value={branchData.name} onChange={handleInputChange} required>
              <option value="">지사를 선택하세요</option>
              {branchOptions.map(branch => <option key={branch} value={branch}>{branch}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>대표자</label>
            <input type="text" name="representative" value={branchData.representative} onChange={handleInputChange} required />
          </div>
          <div className="form-group">
            <label>주소</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <input
                type="text"
                name="address"
                value={branchData.address}
                readOnly
                placeholder="주소 검색 버튼을 클릭하세요"
                style={{ flexGrow: 1 }}
              />
              <button type="button" className="action-button" onClick={handleAddressSearch} style={{ whiteSpace: 'nowrap' }}>
                주소 검색
              </button>
            </div>
          </div>
          <div className="form-actions">
            <button type="submit" className="submit-button">등록하기</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddBranchModal;
